import script from "./imageDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./imageDialog.vue?vue&type=script&setup=true&lang=js"

import "./imageDialog.vue?vue&type=style&index=0&id=dcf4bd90&lang=css"

const __exports__ = script;

export default __exports__